'use client'

import { ActivityIndicator } from '@populix/pop-ui'
import { createPortal } from 'react-dom'

const PageLoading = ({ show }: { show: boolean }) => {
  return (
    show &&
    createPortal(
      <div className='fixed inset-0 z-50 flex h-screen w-screen flex-col items-center justify-center gap-4 bg-black/50'>
        <ActivityIndicator size='large' />
        <p className='text-xs text-white'>Please wait</p>
      </div>,
      document.body,
    )
  )
}

export default PageLoading
